<div>
    <div class="d-flex align-items-center" mat-dialog-title>
        <div class="spacer title">Materieel</div>
        <div>
            <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
        </div>
    </div>
</div>

<div class="dialog-content" mat-dialog-content>
    <mat-slide-toggle class="mb-3" (change)="showFinished($event.checked)">
        Toon materieel dat uit dienst is
    </mat-slide-toggle>

    <button class="ms-3" [disabled]="isSyncing()" (click)="sync()" color="primary" mat-raised-button>
        @if (isSyncing()) {
            <i class="fas fa-spinner fa-spin"></i>
        }
        Synchroniseren met AFAS
    </button>

    @for (entityGroup of entities; track entityGroup.type) {
        <div class="mb-3 ps-3">
            <div class="d-flex justify-content-center align-content-center">
                <h3 class="spacer">
                    {{ entityGroup.type.plural_name }}
                </h3>
            </div>
            <div class="pl-4">
                <table
                    class="table table-hover"
                    [class.table-add-row]="!entityGroup.type.afas_name"
                    (cdkDropListDropped)="drop($event, entityGroup)"
                    cdkDropList>
                    <tr>
                        <th>Naam</th>
                        <th width="100" class="text-center">Boeking</th>
                        @if (entityGroup.type.has_driver) {
                            <th width="200">Voorkeurschauffeur</th>
                        }
                        @if (entityGroup.type.has_lowloader) {
                            <th width="250">Dieplader</th>
                        }
                        @if (entityGroup.type.has_preferred_team) {
                            <th width="250">Voorkeursploeg</th>
                        }
                        @if (entityGroup.type.has_truck) {
                            <th width="250">Trekkend voertuig</th>
                        }
                        <th class="datetime">Begindatum</th>
                        @if (includeFinished) {
                            <th class="datetime">Einddatum</th>
                        }
                    </tr>
                    @for (entity of entityGroup.entities; track entity) {
                        <tr class="curpoint" (click)="openEntity(entity)" cdkDrag>
                            <td class="drag">
                                <div class="drag-handle" cdkDragHandle>
                                    <i class="fa fa-th-list"></i>
                                </div>
                                <div class="ellipsis">
                                    {{ entity.name }}
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="d-flex justify-content-around">
                                    @if (entity.exclude_driving_hours) {
                                        <i class="fa fa-truck-container-empty"></i>
                                    } @else {
                                        <i class="fa fa-truck-field"></i>
                                    }
                                    @if (entity.default_transport_none) {
                                        <i class="fa-duotone fa-xmark"></i>
                                    } @else if (entity.default_transport_home) {
                                        <i class="fa-duotone fa-house-user"></i>
                                    } @else {
                                        <i class="fa-duotone fa-person-digging"></i>
                                    }
                                </div>
                            </td>
                            @if (entityGroup.type.has_driver) {
                                <td>
                                    <div class="ellipsis">
                                        {{ (users | byId: entity.driver_user_id)?.name }}
                                    </div>
                                </td>
                            }
                            @if (entityGroup.type.has_lowloader) {
                                <td>
                                    <div class="ellipsis">
                                        {{ (allEntities | byId: entity.lowloader_entity_id)?.name }}
                                    </div>
                                </td>
                            }
                            @if (entityGroup.type.has_preferred_team) {
                                <td>
                                    <div class="ellipsis">
                                        {{ (allEntities | byId: entity.team_entity_id)?.name }}
                                    </div>
                                </td>
                            }
                            @if (entityGroup.type.has_truck) {
                                <td>
                                    <div class="ellipsis">
                                        {{ (allEntities | byId: entity.truck_entity_id)?.name }}
                                    </div>
                                </td>
                            }
                            <td class="datetime">
                                {{ entity.begindate | date: 'd MMM yyyy' }}
                            </td>
                            @if (includeFinished) {
                                <td class="datetime">
                                    {{ entity.enddate | date: 'd MMM yyyy' }}
                                </td>
                            }
                        </tr>
                    }
                    @if (!entityGroup.type.afas_name) {
                        <tr>
                            <td
                                [attr.colspan]="
                                    (includeFinished ? 4 : 3) + (extraColsMap.get(entityGroup.type.key) ?? 0)
                                ">
                                <button class="w-100" (click)="addEntity(entityGroup.type)" color="primary" mat-button>
                                    {{ entityGroup.type.name }} toevoegen <i class="fas fa-plus"></i>
                                </button>
                            </td>
                        </tr>
                    }
                </table>
            </div>
        </div>
    }
</div>
